<template>
  <div class="hvh-dl hvh-dl--inline hvh-flex end wrap mb-4">
    <v-card class="grow-1 m-0">
      <v-card-text class="text-xs-center">
        <h2 class="pb-1">Patients</h2>
        <v-tooltip right v-if="!isLoading">
          <template v-slot:activator="{ on }">
            <v-progress-circular :rotate="-90" :size="90" :width="15" :value="(numOfPatients / totalPatients) * 100" color="primary" v-on="on">
              <div>
                {{ formatNumber(numOfPatients) }}
              </div>
            </v-progress-circular>
          </template>
          <div>Number of Patients: {{ formatNumber(numOfPatients) }}</div>
          <div>Total Number of Patients: {{ formatNumber(totalPatients) }}</div>
        </v-tooltip>
        <dd v-else>
          <v-progress-linear class="my-2" height="6" :indeterminate="true" />
        </dd>
      </v-card-text>
    </v-card>
    <v-card class="grow-1 m-0">
      <v-card-text class="text-xs-center h-100">
        <div class="hvh-flex column space-between h-100">
          <h2 class="pb-1">Average Cost PMPM:</h2>
          <template v-if="!isLoading">
            <div>
              <h3 class="pb-1"> ${{ formatNumber(Math.round(averageCost))}}</h3>
            </div>
          </template>
          <dd v-else><v-progress-linear class="my-2" height="6" :indeterminate="true"></v-progress-linear></dd>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { customNumberFormat, Debouncer, hashCode } from '../../../../libraries/common';
export default {
  props: ['totalPatients', 'numOfPatients', 'averageCost', 'isLoading', 'filterObject'],
  data() {
    return {
      debouncer: new Debouncer(2000),
    };
  },
  computed: {
    filterHash() {
      return hashCode(this.filterObject || {});
    },
  },
  methods: {
    formatNumber(num) {
      return num >= 1000000 ? new Intl.NumberFormat('en-US', { notation: 'compact', compactDisplay: 'short' }).format(num)
        : customNumberFormat(num);
    },
  },
  watch: {
    filterHash() {
      this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
    },
  },
  mounted() {
    this.$emit('refresh-data', this.filterObject);
  },
}
</script>
